import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../layout/common/Footer'
import Header from '../layout/common/Header'
import NavHeader from '../layout/common/NavHeader'
import SidebarTest from '../layout/common/SidebarTest'
import ContentBody from '../layout/theme/ContentBody'

const Themes = () => {
  const userListData =[]
  return (
    <React.Fragment>
      <Helmet>
        <title>Themes</title>
      </Helmet>
      <NavHeader />
      <Header />
      <SidebarTest />
      <ContentBody
        userList={userListData}
        // pageNumber={pageNumber}
        // onChangePageNumber={onChangePageNumberHandler}
        // usersPerPage={perPageRecords}
        // pageCount={pageCount}
        // onChangeSortClick={sortOnClickHandler}
        // onChangeSortType={sortTypeOnClickHandler}
        // onStatusRecordChange={onStatusRecordChangeHandler}
        // onSearchChang={searchValueChange}
        // onPerPageChange={pageChange}
        // onChangeStatus={statusChangeHandler}
        // statusChange={statusChange}
        // onShowUserOnMainPage={showUserOnMainPageHandler}
      />
      <Footer />
    </React.Fragment>
  )
}

export default Themes
